import {
  createRecognitionCameraAsync,
  deleteRecognitionCameraAsync,
  getAllRecognitionCameraByLicenseAsync,
  getAllRecognitionCameraCountByLicenseAsync,
  getRecognitionCameraByIdAsync,
  getRecognitionCameraGroupsAsync,
  getRecognitionCamerasByIdsAsync,
  updateConfigRecognitionCameraAsync,
  updateRecognitionCameraAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateRecognitionCameraAsync = () =>
  useMutation(createRecognitionCameraAsync);

export const useGetRecognitionCameraByIdAsync = () =>
  useMutation(getRecognitionCameraByIdAsync);

export const useGetAllRecognitionCameraByLicenseAsync = () =>
  useMutation(getAllRecognitionCameraByLicenseAsync);

export const useUpdateRecognitionCameraAsync = () =>
  useMutation(updateRecognitionCameraAsync);

export const useDeleteRecognitionCameraAsync = () =>
  useMutation(deleteRecognitionCameraAsync);

export const useGetRecognitionCameraGroupsAsync = () =>
  useMutation(getRecognitionCameraGroupsAsync);

export const useUpdateConfigRecognitionCameraAsync = () =>
  useMutation(updateConfigRecognitionCameraAsync);

export const useGetRecognitionCamerasByIdsAsync = () =>
  useMutation(getRecognitionCamerasByIdsAsync);

export const useGetAllRecognitionCameraByLicenseCountAsync = () =>
  useMutation(getAllRecognitionCameraCountByLicenseAsync);
